module.exports = __webpack_public_path__ + "img/dao-logo.57336bf8.png";